import React, { useState, useEffect, useContext } from 'react';
import api from '../utils/api';
import Modal from '../components/Modal';
import { ToastContext } from '../App';
export default function CreditorDbPage() {
  const [creditors, setCreditors] = useState([]);
  const [search, setSearch] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [form, setForm] = useState({name:'',inn:'',phone:'',address:''});
  const showToast = useContext(ToastContext);
  const load = () => api.get('/creditor-db', {params:{search}}).then(r=>setCreditors(r.data));
  useEffect(() => { load(); }, [search]);
  const handleSave = async () => {
    if(!form.name.trim()) return showToast('Введите название','error');
    try {
      if(editItem) await api.put(`/creditor-db/${editItem.id}`,form);
      else await api.post('/creditor-db',form);
      setShowModal(false); setEditItem(null); setForm({name:'',inn:'',phone:'',address:''}); load();
      showToast(editItem?'Сохранено':'Добавлено');
    } catch { showToast('Ошибка','error'); }
  };
  const openEdit = (c) => { setEditItem(c); setForm({name:c.name,inn:c.inn||'',phone:c.phone||'',address:c.address||''}); setShowModal(true); };
  const handleDelete = async (id) => { if(!window.confirm('Удалить?')) return; await api.delete(`/creditor-db/${id}`); load(); };
  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">База кредиторов</h1>
        <div style={{display:'flex',gap:8}}>
          <div className="search-bar"><input placeholder="Поиск по названию или ИНН" value={search} onChange={e=>setSearch(e.target.value)} /></div>
          <button className="btn btn-primary" onClick={()=>{setEditItem(null);setForm({name:'',inn:'',phone:'',address:''});setShowModal(true);}}>+ Добавить</button>
        </div>
      </div>
      <div className="table-wrap"><table><thead><tr><th>Название</th><th>ИНН</th><th>Телефон</th><th>Юр. адрес</th><th></th></tr></thead><tbody>
        {creditors.map(c=>(<tr key={c.id}><td><strong>{c.name}</strong></td><td>{c.inn||'\u2014'}</td><td>{c.phone||'\u2014'}</td><td style={{maxWidth:300,overflow:'hidden',textOverflow:'ellipsis'}}>{c.address||'\u2014'}</td>
          <td style={{whiteSpace:'nowrap'}}><button className="btn-icon" onClick={()=>openEdit(c)} style={{fontSize:12}}>Ред.</button><button className="btn-icon" onClick={()=>handleDelete(c.id)} style={{fontSize:12,color:'var(--red)'}}>Удал.</button></td></tr>))}
        {!creditors.length&&<tr><td colSpan={5}><div className="empty-state"><p>Нет кредиторов</p></div></td></tr>}
      </tbody></table></div>
      {showModal&&(<Modal title={editItem?'Редактировать':'Добавить кредитора'} onClose={()=>{setShowModal(false);setEditItem(null);}} footer={<><button className="btn btn-secondary" onClick={()=>{setShowModal(false);setEditItem(null);}}>Отмена</button><button className="btn btn-primary" onClick={handleSave}>Сохранить</button></>}>
        <div className="form-group"><label>Название</label><input className="form-input" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} autoFocus /></div>
        <div className="form-row"><div className="form-group"><label>ИНН</label><input className="form-input" value={form.inn} onChange={e=>setForm({...form,inn:e.target.value})} /></div>
        <div className="form-group"><label>Телефон</label><input className="form-input" value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})} /></div></div>
        <div className="form-group"><label>Юр. адрес</label><textarea className="form-textarea" value={form.address} onChange={e=>setForm({...form,address:e.target.value})} /></div>
      </Modal>)}
    </div>
  );
}
